<div class="duna-location-page">
  <app-duna-location-information></app-duna-location-information>

  <section class="location-section">
    <div class="location-section-header">
      <mat-icon>event</mat-icon>
      <h3>Events</h3>
    </div>
    <div class="location-section-body">
      <app-dynamic-table [dynamicInput]="eventsTableInput"></app-dynamic-table>
    </div>
  </section>

  @if (groupsEnabled) {
  <app-duna-user-groups-location></app-duna-user-groups-location>
  }

  <app-duna-user-groups-location-calendar></app-duna-user-groups-location-calendar>

  @if (canViewReports) {
  <app-duna-report-generator></app-duna-report-generator>

  <!-- Same access rule as reports: superadmin/orgadmin/orgbruger, or uddansvarlig on this station -->
  <app-duna-manual-maintenance-minutes></app-duna-manual-maintenance-minutes>
  }
</div>
